const MIN_WIDTH = 720;
const MIN_HEIGHT = 1280;

export const isValidDimensions = (width: number, height: number, rotation?: number): boolean => {
    if (rotation && Math.abs(rotation) === 90) {
        return height >= MIN_WIDTH && width >= MIN_HEIGHT;
    }
    // for all other rotation values - 0, 180, arbitrary values
    // fallback to default dimensions check
    return width >= MIN_WIDTH && height >= MIN_HEIGHT;
};
